import {Box, Flex, Text, Button, useBreakpointValue} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import ResponsiveDataTable from '~/react/components/ResponsiveDataTable'
import EmptyState from '~/react/components/EmptyState'

import {useActivities} from '../../hooks/useActivities'
import StatusCell from '../StatusCell'
import MCoinsCell from '../MCoinsCell'
import DateCell from '../DateCell'

const MostRecentTransactions = () => {
  const {t} = useTranslation('points')
  const navigate = useNavigate()

  const {activities, loading: isLoading} = useActivities({perPage: 5})

  const columns = [
    {
      header: t('points:mostRecentTransactions.table.date'),
      accessorKey: 'date',
      cell: DateCell,
      colSpan: 1,
    },
    {
      header: t('points:mostRecentTransactions.table.description'),
      accessorKey: 'description',
      hidden: useBreakpointValue({base: true, md: false}),
      colSpan: 3,
    },
    {
      header: (
        <Text textAlign="right">
          {t('points:mostRecentTransactions.table.mCoins')}
        </Text>
      ),
      accessorKey: 'mCoinsTransaction',
      cell: MCoinsCell,
      colSpan: 1,
    },
    {
      header: (
        <Text textAlign="right">
          {t('points:mostRecentTransactions.table.state')}
        </Text>
      ),
      accessorKey: 'currentState',
      cell: StatusCell,
      colSpan: 1,
    },
  ]

  return (
    <Box>
      {activities.length > 0 ? (
        <>
          <Flex direction="column" justify="space-between" gap="sm">
            <Text textStyle="headline5" textTransform="uppercase">
              {t('points:mostRecentTransactions.heading')}
            </Text>
            <Text textStyle="headline3">
              {t('points:mostRecentTransactions.subHeading')}
            </Text>
          </Flex>
          <Box py="md">
            <ResponsiveDataTable
              columns={columns}
              data={activities}
              isLoading={isLoading}
              variant="cashIn"
            />
          </Box>
          <Box py="md">
            <Button
              variant="secondary"
              onClick={() => navigate('/points/transactions')}
            >
              {t('points:mostRecentTransactions.buttons.viewMore')}
            </Button>
          </Box>
        </>
      ) : (
        <EmptyState
          heading={t('points:mostRecentTransactions.noActivity.heading')}
          subHeading={t('points:mostRecentTransactions.noActivity.subHeading')}
        />
      )}
    </Box>
  )
}

export {MostRecentTransactions}
